"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateful = void 0;
var React = __importStar(require("react"));
var widget_1 = require("../basics/widget");
var options_1 = require("../basics/options");
/**
 * @deprecated Don't use directly, use the [[stateful]] function instead.
 */
var Stateful = /** @class */ (function (_super) {
    __extends(Stateful, _super);
    function Stateful(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { value: props.input };
        return _this;
    }
    Stateful.prototype.registerKeyDown = function () {
        var _this = this;
        if (this.onKeyDown)
            window.removeEventListener("keydown", this.onKeyDown);
        if (this.props.options != undefined && this.props.options.onKeyDown != undefined) {
            var onKeyDown_1 = this.props.options.onKeyDown;
            this.onKeyDown = function (e) {
                var res = onKeyDown_1(_this.state.value)(e);
                if (res.kind == "r") {
                    e.preventDefault();
                    _this.on_new_state(res.v);
                    return false;
                }
                return true;
            };
            window.addEventListener("keydown", this.onKeyDown);
        }
    };
    Stateful.prototype.componentDidMount = function () {
        this.registerKeyDown();
        this.on_new_state(this.state.value);
    };
    Stateful.prototype.componentDidUpdate = function (nextProps) {
        this.registerKeyDown();
        if (this.props.options != undefined && this.props.options.mergeNewProps != undefined) {
            var mergeNewProps_1 = this.props.options.mergeNewProps;
            this.setState(function (s) { return (__assign(__assign({}, s), { value: mergeNewProps_1(s.value, nextProps.input) })); });
        }
    };
    Stateful.prototype.componentWillUnmount = function () {
        if (this.onKeyDown)
            window.removeEventListener("keydown", this.onKeyDown);
    };
    Stateful.prototype.on_new_state = function (new_s) {
        var _this = this;
        this.setState(function (s) { return (__assign(__assign({}, s), { value: new_s })); }, function () { return _this.props.on_done_s(new_s); });
    };
    Stateful.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, { key: (0, options_1.option)("key", this.props.options) }, this.props.widget_s(this.state.value).run(function (new_s) { return _this.on_new_state(new_s); }));
    };
    return Stateful;
}(React.Component));
/** It is a wrapper that takes an [[IOWidget]] and enhances it with the ability of having "memory", i.e. state.
 *
 * A plain (stateless) [[IOWidget]] simply takes an input, renders something and produces some output (to possibly feed to other widgets).
 * The output is lost the next time the IOWidget is re-rendered, because the React app has been updated.
 *
 * @param options
 */
var stateful = function (options) {
    return function (widget_s) { return function (input) { return (0, widget_1.fromJSX)(function (on_done_s) {
        return React.createElement(Stateful, { on_done_s: on_done_s, widget_s: widget_s, input: input, options: options });
    }); }; };
};
exports.stateful = stateful;
